module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/slideshow_desktop2-535ed751fb56950d7eac778ee204bc4c.jpg";